define('modules/duplicate_control/model',['require','exports','module','backbone','env','i18n'],function(require, exports, module){
  "use strict";

  var Backbone = require('backbone'),
    config = require("env"),
    i18n = require('i18n'),
    MDIRECTOR_TYPE = 'MDirector',
    EMBLUE_TYPE = 'EmBlue',
    IGNORE = 'ignore';

  var DuplicateControlModel = Backbone.Model.extend({
    defaults: function () {
      return {
        on_duplicated_key: IGNORE,
        error_message: i18n.t('common.duplicatedErrorMessage')
      };
    },
    urlRoot: function(){
      return config.apiHost + "/duplicate-control";
    }
  });

  DuplicateControlModel.MDIRECTOR_TYPE = MDIRECTOR_TYPE;
  DuplicateControlModel.EMBLUE_TYPE = EMBLUE_TYPE;

  DuplicateControlModel.create = function(pageId, type) {
    return new DuplicateControlModel({pageId: pageId, type: type});
  };

  module.exports = DuplicateControlModel;

});

